/* src/app/project/project.component.scss */
.wrapper {
  padding: 10px;
}
ul li {
  text-align: center;
  border-radius: 20px;
  width: 150px;
  min-width: 150px;
  height: 150px;
  min-height: 150px;
  background-color: rgba(231, 235, 241, 0.2);
  float: left;
  margin: 10px;
  cursor: pointer;
}
ul li:hover {
  background-color: rgba(231, 235, 241, 0.3);
}
/*# sourceMappingURL=project.component.css.map */
